import React, { FunctionComponent } from 'react';

import GlobalBaseStyles from './GlobalBaseStyles';
import GlobalFormStyles from './GlobalFormStyles';

const GlobalStyles: FunctionComponent = () => (
  <>
    <GlobalBaseStyles key="glob-base-styles" />
    <GlobalFormStyles key="glob-form-styles" />
  </>
);

export default GlobalStyles;
